import { useState } from 'react';

// styles
import {
    CombineModalContainer,
    CombineModalContent
} from './CombineModal.styles.js';

// components
import InputBar from '../../../../components/input-bar/InputBar.js';
import InputTextfield from '../../../../components/input-textfield/InputTextfield.js';
import InputTags from '../../../../components/input-tags/InputTags.js';
import PrimaryBtn from '../../../../components/btns/primary-btn/PrimaryBtn.js';

export default function CombineModal({ isOpen, onClose, onSubmit, formData, setFormData }) {
    const [currentTagInput, setCurrentTagInput] = useState('');

    const handleFormChange = (field, value) => {
        setFormData(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const handleTagsKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault();
            const newTag = currentTagInput.trim();
            if (newTag && !formData.tags.includes(newTag)) {
                setFormData(prev => ({
                    ...prev,
                    tags: [...prev.tags, newTag]
                }));
                setCurrentTagInput('');
            }
        }
    };

    const removeTag = (tagToRemove) => {
        setFormData(prev => ({
            ...prev,
            tags: prev.tags.filter(tag => tag !== tagToRemove)
        }));
    };

    if (!isOpen) return null;

    return (
        <CombineModalContainer>
            <CombineModalContent className='widget-bg'>
                <h2>Combine Sets</h2>

                <InputBar
                    type="text"
                    id="set-combine-name"
                    label="Set Name *"
                    value={formData.title}
                    updateValue={(value) => handleFormChange('title', value)}
                    pH="Enter combined set name"
                />

                <InputTextfield
                    id="set-combine-description"
                    label="Description"
                    value={formData.description}
                    updateValue={(value) => handleFormChange('description', value)}
                    pH="Enter set description (optional)"
                    rows={3}
                />

                <InputTags
                    id="set-combine-tags"
                    label="Tags"
                    value={currentTagInput}
                    updateValue={setCurrentTagInput}
                    onKeyDown={handleTagsKeyPress}
                    tags={formData.tags}
                    onRemoveTag={removeTag}
                    pH="Type a tag and press Enter to add"
                />

                <div style={{
                    display: "flex",
                    justifyContent: "space-between",
                    width: "100%"
                }}>
                    <PrimaryBtn
                        title="CANCEL"
                        onClick={onClose}
                    />
                    <PrimaryBtn
                        title="COMBINE"
                        onClick={onSubmit}
                        disabled={!formData.title.trim()}
                    />
                </div>
            </CombineModalContent>
        </CombineModalContainer>
    )
}
